import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ErrorBoundary } from '@lusha/client-utils';
import { BrazeProvider } from '@lusha/lusha-braze';
import { AnalyticsContextProvider } from '@lusha-engage/analytics';
import { ExperimentsProvider } from '@lusha-growth/experiment-react-sdk';
import { observer } from 'mobx-react';
import React from 'react';
import config from './config';
import { useMST } from './hooks/MSTHook';
import { APP_ID } from './utils/constants';
import ErrorScreen from './views/ErrorScreen';
const event_additional_info = {
    plugin_version: config.version,
};
function AppUserContext(props) {
    const { children } = props;
    const { user, userSettings } = useMST(store => ({ user: store.user, userSettings: store.userSettings }));
    const { isPluginOpen } = userSettings;
    const isFlagsEnabled = !!isPluginOpen && !!(user === null || user === void 0 ? void 0 : user.id);
    return (_jsx(ErrorBoundary, { additionalInfo: { subPlatform: userSettings.platform }, customErrorComponent: _jsx(ErrorScreen, {}), children: _jsx(ExperimentsProvider, { appId: APP_ID, isLoggedIn: isFlagsEnabled, children: _jsx(BrazeProvider, { user: user, children: _jsx(AnalyticsContextProvider, { event_page_state_str: 'plugin', event_additional_info: event_additional_info, children: children }) }, user === null || user === void 0 ? void 0 : user.id) }) }));
}
export default observer(AppUserContext);
